import axios from 'axios';
import store from '@/store/vuex.js';
import { isNull } from '@/functions/Util';

// Full config:  https://github.com/axios/axios#request-config
const api = axios.create({
    // pega url do server
    baseURL: process.env.VUE_APP_API_URL || '',
    headers: {
        'Content-Type': 'application/json',
        Authorization: $cookies.get('token') || '',
        'X-App-version-id': $cookies.get('version') || '',
        'Gr-Token': null,
    },
    timeout: 60 * 2000, // Timeout 1 min
});

// captura requisição e faz pré-intervensões
api.interceptors.request.use(
    (request) => {
        if (
            request.headers.Authorization != $cookies.get('token') ||
            request.headers['X-App-version-id'] != $cookies.get('version')
        ) {
            request.headers.Authorization = $cookies.get('token') || '';
            request.headers['X-App-version-id'] = $cookies.get('version') || '';
        }
        return request;
        // console.log('Url |', request.url);
    },
    (error) => {
        return Promise.reject(error);
    }
);

// captura resposta e faz pré-intervensões
api.interceptors.response.use(
    (response) => {
        // caso venha código de autenticação na resposta do server
        if (response.config.url == 'user/login' && !isNull(response.headers.authorization)) {
            // pega o token vindo do server
            api.defaults.headers.Authorization = response.headers.authorization;
            api.defaults.headers['X-App-version-id'] = response.headers.version;
            // Calculando tempo dependendo da opção de manter conectado
            // let timeToExpire = '1h'; // uma hora
            // if ($cookies.get('keepLogged') && $cookies.get('keepLogged') == 'true') {
            //     timeToExpire = '1m'; // um mês
            // }
            // Adiciona o cookie atualizado no token para ser usado na primeira requisição
            // $cookies.set('token', response.headers.authorization, timeToExpire);
            // $cookies.set('version', response.headers.version, timeToExpire);
            $cookies.set('token', response.headers.authorization);
            $cookies.set('version', response.headers.version);
        }

        return response;
    },
    (error) => {
        //faz logout se uma request retornar status 403. porém, se a request é de "usuario", não precisa chamar logout, visto que não foi feito login
        if (process.env.NODE_ENV === 'development') {
            console.log('error', error);
        }
        if (error.response.status === 401 && error.config.url != 'user/login') {
            store.dispatch('authenticated', { value: false });
        }

        return Promise.reject(error.response);
    }
);

export default api;
